<template>
    <div class="goal-form" v-if="editReps">
        <div v-show="submit_form_errors" class="validate-warning-msg-login">{{ submit_form_errors }}</div>
        
        <div class="form-group row">
            <label class="col-12 col-sm-4 col-md-4 col-lg-5 col-xl-5 goal_label">Time spent on task:<span class="required">*</span></label>
            <div class="col-12 col-sm-8 col-md-8 col-lg-7 col-xl-7">
            <date-picker 
                name="Time spent on task"
                v-model="display_time" 
                v-validate="'required'"
                type="time" 
                placeholder="Hours:Minutes"
                :popup-style="timePickerStyle"
                format="HH:mm"
                @change="inputHandler"
                v-bind:clearable="false"
                v-bind:editable="false"
                ref="timepicker">
            </date-picker>
            <div v-if="verrors.firstByRule('Time spent on task', 'required')" :class="'validate-warning-msg '  + vmessage">Time spent on task is required</div>
            </div>
        </div>
        <div class="form-group row" v-if="subTaskId != 99999">
            <label class="col-12 col-sm-4 col-md-4 col-lg-5 col-xl-5 goal_label">Comment for mentee:</label>
            <div class="col-12 col-sm-8 col-md-8 col-lg-7 col-xl-7">
            <textarea 
                name="Comment for mentee"
                class="form-control"
                v-model="comment"
                placeholder="How did the mentee do on this task?"
                maxLength="180"
                @blur="characterCount"
                @input="characterCount">
            </textarea>
            <span class="hint">{{ this.remainCharacters + ' Characters' }}</span>
            </div>
        </div>
        <div class="form-group row" v-if="subTaskId != 99999">
            <label class="col-12 col-sm-4 col-md-4 col-lg-5 col-xl-5 goal_label">Rate This Repetition:<span class="required">*</span></label>
            <div class="col-12 col-sm-8 col-md-8 col-lg-7 col-xl-7">
            <select 
                name="Rate This Repetition"
                v-validate="'required'" 
                v-model="score" 
                class="form-control">
                <option value="">Select Rating</option>
                <option v-for="(item, index) in score_options" :key="index" :value="item.value">{{ item.display }}</option>
            </select>
            <div v-if="verrors.firstByRule('Rate This Repetition', 'required')" :class="'validate-warning-msg ' + vmessage">Rate This Repetition is required</div>
            </div>
        </div>
        <div v-if="showWait == false" class="text-center mt-4">
            <button type="submit" class="btn btn-sm edit-rep-btn text-center" v-on:click="onSubmit()">Save</button>
        </div>
        <div v-if="showWait == true" class="text-center mt-4">
            <button type="submit" class="btn btn-sm edit-rep-btn text-center">Please wait...</button>
        </div>
        
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const today = new Date();
today.setHours(0, 0, 0, 0);

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['menteeId','tasklistId','taskId','subTaskId','editReps','score_options'],
    data(){
        return {
            submit_form_errors: '',
            timePickerStyle: {},
            remainCharacters: 180,
            comment: '',
            display_time: '',
            timeOnTask: '',
            score: '',
            assessment_id: '',
            vmessage: '',
            showWait: false,
        }
    },
    components: {
        DatePicker
    },
    methods: {
        getRepItem(item) {
            this.comment = item.comment;
            this.score = item.score;
            this.timeOnTask = item.timeOnTask;
            this.assessment_id = item.id;
            if(item.minutes > 0) {
                this.display_time = new Date();
                this.display_time.setHours(item.hours);
                this.display_time.setMinutes(item.minutes);
            }
            else {
                this.display_time = new Date();
                this.display_time.setHours(item.hours);
                this.display_time.setMinutes('00');
            }
            this.timePickerStyle['left'] = '50%';
            this.timePickerStyle['top'] = '50%';
            this.timePickerStyle['transform'] = 'translate(-30%, -60%)';
            this.timePickerStyle['z-index'] = '9999';
        },
        characterCount: function() {
            if(this.comment.length > 0){
                this.remainCharacters = 180 - this.comment.length;
            }
        },
        inputHandler(eventData) {
            var d = new Date(eventData);
            var hours = d.getHours();
            var mins = d.getMinutes();
            let hourMins = hours*60;
            this.timeOnTask = hourMins + mins;
            if (hours >= 0 && mins > 0) {
                this.$refs.timepicker.closePopup();
            }
        },
        onSubmit() {
            this.vmessage = "show_vmessage";
            this.$validator.validateAll().then((result) => {
                if(!result){
                    return;
                }
                this.updateRepetition();
            }).catch(() => {
                // catches the error;
            });
        },
        updateRepetition() {
            if (this.timeOnTask > 0) {
                this.showWait = true;
                axios('/desktop/mentee/ratingrepetition/update',
                {
                    method: 'PATCH',
                    data: {
                        comment: this.comment,
                        time_on_task: this.timeOnTask,
                        mentee_id: this.menteeId,
                        task_id: this.taskId,
                        tasklist_id: this.tasklistId,
                        subtask: this.subTaskId,
                        score: this.score,
                        assessment_id: this.assessment_id,
                        "account_id": this.$store.state.user_accountid,
                    },
                }
                )
                .then(() => {      
                    this.flash({ message: 'Repetition updated successfully', variant: 'success' });
                    this.$parent.navigate();
                    //this.showWait = false;     
                })
                .catch((error) => {
                    console.log(error)
                });
            } else {
                alert("Please select time spent on task");
            }
        }
    }
}
</script>
<style scoped>
.edit-rep-btn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 150px;
}
.mx-datepicker { width: 100%; }
.goal_label {
   font-weight: 900; 
}
</style>


// WEBPACK FOOTER //
// src/components/manager/edit_repetition.vue